import { Component, OnDestroy, OnInit, Input } from '@angular/core';
import { filter, Observable, Subscription } from 'rxjs';
import { User } from '../../models/user/user.model';
import { AuthService } from '../../services/auth.service';
import {
    NavigationService,
    NavigationServiceGroup,
    NavigationServiceMenu,
} from '../../services/navigation.service';
import { NotificationService } from '../../services/notification.service';
import { FranchiseService } from '../../services/franchise.service';
import { Franchise } from '../../models/franchise.model';
import { PhonePipe } from '../../pipes/phone.pipe';
import { RoleAnyPipe } from '../../pipes/role-any.pipe';
import { UserNamePipe } from '../../pipes/user-name.pipe';
import { TranslocoModule } from '@jsverse/transloco';
import { AvatarComponent } from '../avatar/avatar.component';
import { AppLanguageSwitcherComponent } from '../app-language-switcher/app-language-switcher.component';
import { NavigationEnd, Router, RouterLink, RouterLinkActive } from '@angular/router';

@Component({
    selector: 'app-header',
    templateUrl: './app-header.component.html',
    styleUrls: ['./app-header.component.scss'],
    imports: [
        RouterLink,
        AppLanguageSwitcherComponent,
        AvatarComponent,
        RouterLinkActive,
        TranslocoModule,
        UserNamePipe,
        RoleAnyPipe,
        PhonePipe,
    ],
})
export class AppHeaderComponent implements OnInit, OnDestroy {
    protected subscriptions: Subscription[] = [];

    user: User | null = null;
    now: Date = new Date();
    navigation: NavigationServiceMenu[] = [];
    navigationGroups: NavigationServiceGroup[] = [];
    company: Franchise | null = null;

    navCalendarHide: boolean = false;
    navMessagesHide: boolean = false;
    navStoreHide: boolean = false;

    notificationMessageCount: number = 0;
    notificationOrdersCount: number = 0;

    constructor(
        protected router: Router,
        protected authService: AuthService,
        protected navigationService: NavigationService,
        protected notificationService: NotificationService,
        protected franchiseService: FranchiseService,
    ) {}

    ngOnInit(): void {
        this.user = this.authService.getUser() ?? this.user;

        const navigationSubscription = this.navigationService
            .getNavigation()
            .subscribe((navigation) => {
                this.navigation = navigation;
                this.navigationGroups = this.navigationService.groupNavigation(navigation);
            });
        this.subscriptions.push(navigationSubscription);

        const authSubscription = this.authService
            .getStatus()
            .subscribe((status) => {
                this.user = this.authService.getUser();

                this.navStoreHide = !this.user?.can(['admin']) || this.navStoreHide;

            });
        this.subscriptions.push(authSubscription);

        const notificationsCountSubscription = this.notificationService.getNotifications()
            .subscribe(data => {
                this.notificationMessageCount = data?.messages ?? 0;
                this.notificationOrdersCount = data?.orders ?? 0;
            });
        this.subscriptions.push(notificationsCountSubscription);

        const companySubscription = this.franchiseService
            .getCompanyDetails()
            .subscribe((company) => {
                this.company = company;

                this.navCalendarHide = this.company?.isPreference('mainmenu.hide.calendar', true) ?? false;
                this.navMessagesHide = this.company?.isPreference('mainmenu.hide.messages', true) ?? false;
                this.navStoreHide = !this.user?.can(['admin'])
                    || (this.company?.isPreference('mainmenu.hide.store', true) ?? false);
            });
        this.subscriptions.push(companySubscription);
    }

    ngOnDestroy(): void {
        this.subscriptions?.map((subscription) => subscription?.unsubscribe());
    }
}
